<!--
 * @Description: 
 * @Author: Niklaus
 * @Date: 2025-08-14 17:21:24
 * @LastEditors: Niklaus
 * @LastEditTime: 2025-08-14 17:22:59
-->
<template>
  <div>本年度实收明细</div>
</template>
<script>
export default {}
</script>
<style lang=""></style>
